export default {
  REGISTRATION: /(^[A-Za-z0-9]{2} [A-Za-z0-9]{3,}$)|(^[pP] [0-9]{5}$)|(^[cC][vV] [0-9]{5}$)|(^[mM] [0-9]{4}$)|(^[cC][mM][dD] [0-9]{4}$)|(^[cC][dD] [0-9]{4}$)/,
}
